export enum PageRoutes {
  AUTH_ERROR = '/auth-error',
  LOGIN = '/login',
  HOME = '/*',
  TERMS = '/terms',
  DASHBOARD = '/dashboard',
  BILLING_REMINDER = '/billing-reminder',
  CALLBACK = '/callback',
  INVOICES = '/invoices/:invoiceId',
  ACCESS_DENIED = '/access-denied',
  RESEND_ACTIVATION = '/send-activation',
  NOA_CENTER = '/noa-center',
  COMMUNICATION_PREFERENCES = '/communication-preferences',
}
